export const incident = {
    name: '',
    priority: null,
    account: '',
    client: '',
    site: '',
    status: 'ACTIVE',
}
